import { computePodcastTotals, computePodcastComparison } from "./podcastsAnalyticsMetrics"
import { formatDateRange } from "@/common/helpers/comparisonMetrics.helper"

// ---------------------------------------------------------------------------
// Raw dataset accessors
// ---------------------------------------------------------------------------

export const podcastsAnalytics = (state) => state.datasets.primary

// ---------------------------------------------------------------------------
// Derived data (primary)
// ---------------------------------------------------------------------------

export const summaryStats = (state) => {
  const ds = state.datasets.primary
  if (ds?.summaryStats && ds.summaryStats.totalBytes) {
    return ds.summaryStats
  }
  return false
}

export const periodStats = (state) => {
  return state.datasets.primary?.periodDateStats || []
}

export const episodeDateStats = (state) => {
  return state.datasets.primary?.episodeDateStats || []
}

// ---------------------------------------------------------------------------
// Derived data (comparison)
// ---------------------------------------------------------------------------

export const comparisonSummaryStats = (state) => {
  const ds = state.datasets.comparison
  if (ds?.summaryStats && ds.summaryStats.totalBytes) {
    return ds.summaryStats
  }
  return false
}

export const comparisonPeriodStats = (state) => {
  return state.datasets.comparison?.periodDateStats || []
}

// ---------------------------------------------------------------------------
// Params & flags
// ---------------------------------------------------------------------------

export const params = (state) => state.params
export const comparisonParams = (state) => state.comparisonParams
export const isComparisonMode = (state) => state.isComparisonMode
export const analyticsSelectedPodcasts = (state) => state.selectedPodcasts
export const analyticsPeriod = (state) => state.params

export const isDataFetched = (state) => state.datasets.primary !== null

// ---------------------------------------------------------------------------
// Date range labels
// ---------------------------------------------------------------------------

export const dateRangeLabel = (state) => formatDateRange(state.params)
export const comparisonDateRangeLabel = (state) => formatDateRange(state.comparisonParams)

// ---------------------------------------------------------------------------
// Computed totals & comparison metrics
// ---------------------------------------------------------------------------

/** All primary metric totals in one object */
export const primaryTotals = (_, getters) => computePodcastTotals(getters.summaryStats)

/** All comparison metric totals in one object */
export const comparisonTotals = (_, getters) => computePodcastTotals(getters.comparisonSummaryStats)

/**
 * Combined metrics with delta / percentChange / trend for every metric key.
 * Returns null when comparison mode is off.
 * Each key: { value, comparisonValue, delta, percentChange, trend }
 */
export const metrics = (state, getters) => {
  if (!state.isComparisonMode) return null
  return computePodcastComparison(getters.primaryTotals, getters.comparisonTotals)
}
